<template>
	<div class="p-4" :style="{background: data.data.section_background}">
		<div class="container">
			<h3 v-if="this.data.show_title" :style="{color: data.data.section_title_color}">{{ this.data.title }}</h3>
			<faqs-section
					:faqs='this.data.data.items'
					:title-color="data.data.title_color"
					:title-background="data.data.title_background"
					:content-background="data.data.content_background"
					:content-text-color="data.data.content_text_color"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {PageComponentInterface} from "../Interfaces/PageComponentInterface";
import FaqsSection from "../../../Components/LayoutSections/FaqsSection.vue";

export default defineComponent({
	name: "FaqPageSection",
	components: {FaqsSection},
	props: {
		data: {
			type: Object as PropType<PageComponentInterface>,
			required: true,
		}
	},
});
</script>

<style scoped>
</style>
